import React, { useState, useEffect } from "react";
import IconNull from "../componentsStyled/icon/iconNull";

import Produtos from "./produtos";
import { Box } from "@mui/material";
import apiConnect from "../api/apiConnect";
import LoadingBox from "./LoadingBox";

interface ListaProdutosProps {
  className?: string;
  selectedOption?: string;
  selectedId?: string;
}

interface Produto {
  product_id: string;
  name?: string;
  variant_value?: string;
  price?: number;
  img?: string;
  url?: string;
}

interface Pedido {
  id: string;
  status: string;
  Products: Produto[];
}

type auth = {
  basicAuth: string;
  code: number;
  email: string;
  customerId: string;
  token: string;
};

const ListaProdutos: React.FC<ListaProdutosProps> = ({ selectedId }) => {
  const [pedido, setPedido] = useState<Pedido | null>(null);
  const [produtoSelecionado, setProdutoSelecionado] = useState<Produto | null>(null);
  const [delivery_date, setDelivery_date] = useState("");
  const [payment_method, setPayment_method] = useState("");
  const [allowed_clique_retire, setAllowed_clique_retire] = useState("");
  const [showProductSelected, setShowProductSelected] = useState(false);
  const [produtosSelecionados, setProdutosSelecionados] = useState<Produto[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const handleGetProductsByPedido = async () => {
    let auth = localStorage.getItem("auth");
    if (selectedId === "#" || auth.length === 0) {
      return;
    }
    setLoading(true);

    const authObj: auth = JSON.parse(auth);

    apiConnect.apiAPP
      .get(`/order/get/${selectedId}`, {
        headers: {
          Authorization: "Basic " + authObj.basicAuth,
        },
      })
      .then(function (response) {
        setPedido(response.data);
        setDelivery_date(response.data.delivery_date || "");
        setPayment_method(response.data.payment_method || "");
        setAllowed_clique_retire(response.data.allowed_clique_retire);
        setShowProductSelected(false);
        setLoading(false);
      })
      .catch(function (error) {
        console.log("error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    setProdutosSelecionados([]);
    setProdutoSelecionado(null);
    handleGetProductsByPedido();
  }, [selectedId]);

  const onSelectProduto = (produto: Produto) => {
    setProdutoSelecionado(produto);
  };

  return (
    <Box>
      <Box display={{ xs: "initial", md: "none" }}>
        <p style={{ color: "#21222D", fontSize: 22, fontWeight: 500, fontFamily: "Helvetica Neue" }}>Pedido #{selectedId}</p>
      </Box>
      <Box display={{ xs: "none", md: "initial" }}>
        <p style={{ color: "#21222D", fontSize: 22, fontWeight: 700, fontFamily: "Helvetica Neue" }}>Pedido: #{selectedId}</p>
      </Box>
      <p style={{ fontSize: 16, marginTop: 20 }}>Selecione o(s) produto(s) que você deseja devolver</p>

      {loading ? (
        <Box marginY={2}>
          <LoadingBox loadType="static" />
        </Box>
      ) : pedido?.Products?.length > 0 ? (
        <Box marginY={2}>
          <Produtos
            produtos={pedido.Products}
            selectedId={selectedId || ""}
            handleSelect={onSelectProduto}
            key={selectedId}
            delivery_date={delivery_date}
            payment_method={payment_method}
            allowed_clique_retire={allowed_clique_retire}
          />
        </Box>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <IconNull width={50} />
          <p style={{ color: "#777" }}>Não há mais itens</p>
          <p style={{ color: "#777" }}>para serem devolvidos nesse pedido.</p>
        </div>
      )}
    </Box>
  );
};

export default ListaProdutos;
